export class WorkOrder {
  admissionInfo: string;
  admittedCrimeNotFound: boolean;
  caseNbr: number;
  checked: Boolean;
  colorValue: string; // *
  crrsrCount: number;
  custId: string;
  deferred: string;
  dis_DueDt: string;  /// same as iso_DueDt per baffey
  dis_RequestDt: string;
  dis_RequestDt_sort: Date;
  dob: string;
  dobDisplay: string; // *
  driversLicense: string;
  emailAddress: string; // aka sourceEmail
  filterText: string;
  filterTotal: number; // count(CR_RequestSpecialRetrieve[@jurisdictionId = $filterText])
  gisUserName: string;
  hrefAttachDoc: string;
  hrefCif: string;
  isLate: Boolean; // *
  iso_DueDt: string;
  iso_SysDt: string;
  jurisdiction: string;
  jurisdictionId: number; // used to calclate filter total
  lateTotal: number; // aka lateRequests
  linkColor:  string;
  manualInd: string;
  max: number;
  min: number;
  nameRefNbr: number; /// refNbr
  newTotal: number;   // aka newRequests....maxNewRequest
  ociIndicator: string;
  pendingComments: string;
  phone: string;
  position: string; // *
  printInd: string;
  recordFound: string;
  refAddr1: string;
  refCity: string;
  refName: string; // searchName (in grid with address)
  refState: string;
  refZip: string;
  reportAll: string;
  reportAllText: string;
  requestNbr: number;
  requestTotal: number; // totalRequests... requests
  searchFromDt: number;
  searchToDt: number;
  showInstruction: string;
  signedRelInd: string;
  sourceName: string;
  sourceType: string;
  specialInstr: string;
  ssn: string;
  ssnDisplay: string; // *
  status: string;
  strWork: string;
  totalInstruction: number; // *
  url: string;
  woNoHitsDisable: Boolean;
  woPendingDisable: Boolean;
  woNoHitsDisplay: string; // *
  woManualDisplay: string; // *
  woPendingDisplay: string; // *
  woPendingLinkDisplay: string; // *
  woRecordDisplay: string; // *
  woCommentsDisplay: string; //  *
  woSearchDisplay: string; // *
  woDeferredDisplay: string; // *
  woAdmittedDisplay: string; // *
  woNoHitsChecked: Boolean; // *
  woManualChecked: Boolean; // *
  woPendingChecked: Boolean; // *
  woDeferredChecked: Boolean; // *
  woAdmittedChecked: Boolean; // *
  woPhone: string; // *
  woValue: string; // *
  woSourceName: string; // *
  woURL: string; // *
  woNoHitsName: string;
  woManualName: string;
  woPendingName: string;
  woDeferredName: string;
  woAdmittedName: string;
  licenseNumber: string;
  isHeightenedIdentifier: Boolean;
}



// WEBPACK FOOTER //
// ./src/models/workOrder.ts